module.exports = "/_next/static/images/fingerprint-af4fc31bc90cfc9c07d98e4896a16674.png";